import React, { useCallback, useEffect, useState } from 'react';
import { subscriptionPix } from '../../../services/creator';
import { Spinner } from 'react-bootstrap';
import Button from '../../../components/Button';
import './styles.css';

type Props = {
  plan: Plan;
  onClose: () => void;
};

const Pix: React.FC<Props> = ({ plan, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [pixQrCodeSrc, setPixQrCodeSrc] = useState('');
  const [pixKey, setPixKey] = useState('');
  const [error, setError] = useState<string | null>(null);

  const fetchPixData = useCallback(async () => {
    try {
      setLoading(true);
      const pixResponse = await subscriptionPix(plan.creatorId, plan.id);
      setPixQrCodeSrc(pixResponse[0].value);
      setPixKey(pixResponse[1].value);
    } catch {
      setError('Ops! Não foi possível carregar os dados PIX');
    } finally {
      setLoading(false);
    }
  }, [plan.creatorId, plan.id]);

  useEffect(() => {
    fetchPixData();
  }, [fetchPixData, plan.creatorId, plan.id]);

  if (error) {
    return (
      <div className="error-container">
        <i className="feather-alert-circle error-icon"></i>
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        <Button
          onClick={() => {
            setError(null);
            fetchPixData();
          }}
        >
          <i className="feather-refresh-ccw me-2"></i>
          Tentar Novamente
        </Button>
      </div>
    );
  }

  const handleCopy = () => {
    if (pixKey) {
      navigator.clipboard.writeText(pixKey);
    }
  };

  return (
    <div className="pix-container">
      {loading ? (
        <div className="pix-loading">
          <Spinner className="text-warning" />
          <span className="loading-text">Gerando código PIX...</span>
        </div>
      ) : (
        <>
          {pixQrCodeSrc && (
            <div className="qr-code-wrapper">
              <div className="pix-header">
                <img src="assets/images/pix-logo.png" alt="PIX" className="pix-logo" />
                <span className="pix-title">Escaneie o QR Code para pagar</span>
              </div>
              <div className="qr-code-container">
                <img
                  src={pixQrCodeSrc}
                  alt="PIX QR Code"
                  className="qr-code-image"
                />
                <div className="qr-code-border"></div>
              </div>
            </div>
          )}
          {pixKey && (
            <div className="pix-copy-section">
              <div className="copy-header">
                <i className="feather-copy copy-icon"></i>
                <span className="copy-title">PIX Copia e Cola</span>
              </div>
              <div className="copy-container">
                <input
                  type="text"
                  value={pixKey}
                  readOnly
                  className="pix-key-input"
                  onFocus={(e) => e.target.select()}
                />
                <button
                  onClick={handleCopy}
                  className="copy-button"
                >
                  <i className="feather-copy"></i>
                  Copiar
                </button>
              </div>
              <p className="copy-instruction">
                Copie o código acima e cole no seu app de pagamento
              </p>
            </div>
          )}
        </>
      )}
      {!loading && (
        <div className="pix-footer">
          <div className="payment-info">
            <i className="feather-check-circle success-icon"></i>
            <p className="payment-message">
              Após o pagamento, sua assinatura será ativada automaticamente
            </p>
          </div>
          <Button
            onClick={onClose}
            className="confirm-button"
          >
            <i className="feather-check"></i>
            Concluído
          </Button>
        </div>
      )}
    </div>
  );
};

export default Pix;
